const moment = require('moment');
const { RESERVATION_STATUS, PAYMENT_TYPE } = require("@arbitrip/constants");

function isRetroactivePointsUsageEnabled({ profile, booking }) {
    // feature is enabled on user or company level
    if (!profile?.loyalty?.retroactive_usage_enabled && !profile?.company?.loyalty?.retroactive_usage_enabled) {
        return false;
    }

    // connected user is the benefactor
    if (profile?.id !== booking?.arbitrip_loyalty_earned?.benefactor) {
        return false;
    }

    // booking is approved
    if (booking?.status !== RESERVATION_STATUS.APPROVED) {
        return false;
    }

    // booking is in the future
    if (!moment(booking?.deal?.details?.check_in).isAfter(moment(), 'day')) {
        return false;
    }

    // booking is company policy or pay later
    if ((booking?.payment?.payment_type !== PAYMENT_TYPE.COMPANY_POLICY)
        && (booking?.payment?.payment_type !== PAYMENT_TYPE.PAY_LATER)) {
        return false;
    }

    // TODO: check post pay with einav (update on server too)

    return true;
}

module.exports = { isRetroactivePointsUsageEnabled };
